import {AfterViewInit, Component, HostListener, ViewChild, ViewContainerRef,} from '@angular/core';
import {ICellEditorParams} from 'ag-grid-community';
import {CustomCellEditorComponent} from '../custom-cell-editor/custom-cell-editor.component';
import {NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {FormControl} from '@angular/forms';
import {
  DateElementComponent
} from '../../../form-control/dynamic-form/form-element/date-element/date-element.component';

interface IDateData {
  year: number | string;
  month: number | string;
  day: number | string;
}

@Component({
  selector: 'app-date-cell-editor',
  templateUrl: './date-cell-editor.component.html',
  styleUrls: ['../custom-cell-editor/custom-cell-editor.component.scss'],
  standalone: true,
  imports: [DateElementComponent],
})
export class DateCellEditorComponent
  extends CustomCellEditorComponent
  implements AfterViewInit {
  @ViewChild(NgbInputDatepicker) datePickerRef: NgbInputDatepicker;
  @ViewChild(DateElementComponent) dateElementRef: DateElementComponent;
  @ViewChild('input', {read: ViewContainerRef}) public override input: ViewContainerRef;

  override params: ICellEditorParams;

  @HostListener('document:click', ['$event'])
  protected override clickOut(event: MouseEvent) {

  }

  override agInit(params: ICellEditorParams): void {
    this.params = params;
    this.oldValue = {...this.params.value};

    const isTyping: boolean = !!params.charPress
      && /^\d$/.test(params.charPress);

    // When typing: initialize with null so NgbInputDatepicker renders an empty input.
    // The charPress character is written directly to the DOM in ngAfterViewInit to bypass
    // NgbInputDatepicker's ControlValueAccessor, which would otherwise discard an invalid date string.
    if (params.value.value && !isTyping) {
      console.log(params.value.value);
      this.textFormControl = new FormControl(params.value.value);
    } else {
      this.textFormControl = new FormControl(null);
    }

    if (params.charPress && !isTyping) {
      this.handlePaste(params);
    }
  }

  override ngAfterViewInit(): void {
    const isTyping: boolean = !!this.params.charPress
      && /^\d$/.test(this.params.charPress);

    if (!isTyping) {
      this.dateElementRef.datePickerRef.open();
    }

    setTimeout((): void => {
      const input: HTMLInputElement = this.dateElementRef.inputRef.nativeElement;
      input.focus();
      if (isTyping) {
        input.value = this.params.charPress;
        input.setSelectionRange(input.value.length, input.value.length);
      }
    });
  }

  override ngOnDestroy() {
    this.saveValue();
  }

  override isCancelAfterEnd() {
    return this.canceled || this.oldValue.value === this.textFormControl.value;
  }

  override getValue(): any {
    return this.params.value;
  }

  override isPopup(): boolean {
    return true;
  }

  protected override saveValue() {
    if (this.isCancelAfterEnd()) {
      return;
    }
    const colDef: any = this.params.colDef;
    if (this.textFormControl.value) {

      const val = this.textFormControl.value;
      super
        .changeLine(
          this.params.data.apiRow.obj,
          this.params.data.apiRow.rowidx,
          colDef.attribute,
          colDef.attributeindex,
          val,
        ).subscribe();
    } else {
      super
        .changeLine(
          this.params.data.apiRow.obj,
          this.params.data.apiRow.rowidx,
          colDef.attribute,
          colDef.attributeindex,
          null,
        ).subscribe();
    }

  }

  protected override handlePaste(params: ICellEditorParams) {
    if (params.charPress === 'delete') {
      super.handlePaste(params);
      return;
    }
    if (params.charPress.includes('#pasted')) {
      const pasted: string = JSON.parse(params.charPress.slice(7));
      this.setPastedValue(pasted);
    }
  }

  protected override setPastedValue(pasted: string) {
    console.log(pasted);
    const dateString = pasted;
    this.textFormControl.patchValue(dateString);
    this.params.value.value = dateString;
    this.params.api.stopEditing();
  }

  private getDateString(value: IDateData): string {
    const year = String(value.year);
    const month = String(value.month);
    const day = String(value.day);
    if (year.length > 4 || month.length > 2 || day.length > 2 || year.length < 1 || month.length < 1 || day.length < 1) {
      console.error('Date does not have the correct form.');
      return '';
    }
    return year + '-' + (month.length === 1 ? ('0' + month) : month) + '-' + (day.length === 1 ? ('0' + day) : day);
  }
}
